import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/omg2.png";
const OMG2 = () => { 
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">OMG 2</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Shreya</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 2</div> <div className="genre">Genre: Comedy</div>
            <p>OMG 2 is the second installment of the OMG Franchise. While the first movie was a wild success with its on-point sarcasm and incredible comedic timing, the second movie doesn’t quite meet the standard.</p>
<br/>
<p>Each OMG movie takes up a social issue, which is shown in a satirical way.</p>
<br/>
<p>The first movie focused on fraudulent religious leaders, or ‘dhongi babas’. Paresh Rawal and Akshay Kumar play the main protagonists of the movie, and they compliment each other beautifully. Paresh Rawal plays Kanji, an atheist who sells idols for a living. Akshay Kumar plays God himself, who descends on Earth to make Kanji (and the audience) understand the real meaning of God- that God is everywhere, not just in temples, and faith should come from within. He tells them not to believe in fraudulent godmen, as their job is to turn religion into business.</p>
<br/>
<p>The second movie focuses on the lack of sex education in the Indian education system. While this is a very pressing issue which needs to be addressed, I found it has little to no relevance with God. The sequel has a similar script as its predecessor, but while the supernatural arrival of God made sense in the first movie (since God and religion was the main topic), I saw no need for God to be present in a movie about sex education. The movie started out with some witty jokes, but soon took a boring turn with the same idea being pushed again and again- that sex education should be included in school syllabus.</p>
<br/>
<p>The film tells the story of Kanti (Pankaj Tripathi), a staunch believer of Lord Shiva. Kanti’s life is upheaved when his son is rusticated on grounds of indecency on school premises. Kanti, initially distraught, prays to Lord Shiva to help him. God(Akshay Kumar) comes to Earth and makes Kanti realize that if sex education was more prevalent in schools, his son would have never behaved so.</p>
<br/>
<p>Akshay Kumar, who plays God and is supposed to be the central character is forgotten until the very end of the movie. He had no influence on the plot, only weaving in and out occasionally to offer advice to Kanti.</p>
<br/>
<p>Overall, the topic of the movie is commendable and relevant to today’s society. Crucial points are brought up and boldly spoken about. But, it would have been better if the movie was done separately and not as a sequel to OMG. OMG 2 very clearly lacks the satire, dialogue delivery and sharp wit that is seen in OMG which may leave the audience disappointed.</p>
          
          <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default  OMG2;

 


